import cn from 'bem-cn';

import { List, Skeleton, Stack } from '../../../UI';

import './ChallengeRequirements.scss';

const b = cn('challenge-requirements');

const renderRequirement = (item: string) => (
    <Stack direction="row" spacing={12} alignItems="center" style={{ width: '100%' }}>
        <Skeleton variant="circular" width={40} height={40} />
        <Skeleton width={item} height={24} />
    </Stack>
);
const extractTagKey = (_: string, index: number) => `skeleton-requirement-${index}`;

export const ChallengeRequirementsSkeleton = () => {
    return (
        <Stack spacing={16} className={b()}>
            <h2 className={b('title')}>
                <Skeleton width="80%" />
            </h2>
            <Stack className={b('list-container')}>
                <List
                    className={b('list')}
                    items={['50%', '80%', '70%', '50%']}
                    renderItem={renderRequirement}
                    keyExtractor={extractTagKey}
                />
            </Stack>
        </Stack>
    );
};
